import JwtBaseClient from './JwtBaseClient';

class TermsOfServiceClient {
  constructor(user) {
    const headers = {
      'Content-Type': 'application/json',
    };
    this.jwtBaseClient = new JwtBaseClient(import.meta.env.VITE_EULA_TOS_SERVICE_URI, headers);
    this.user = user;
    this.uri = 'api/eulaacceptance';
  }

  blanketApproveTermsOfService({ eulaId, acceptedDate }) {
    const data = {
      eulaId,
      acceptedDate,
    };
    return this.jwtBaseClient.post(`${this.uri}/allusersorganizations`, data)
      .then((response) => response.data?.data);
  }

  checkNeedTosAcceptance() {
    return this.jwtBaseClient.get(`${this.uri}/acceptancerequired`)
      .then((response) => response.data?.data);
  }
}
export default TermsOfServiceClient;
